import React, { useState } from "react";

/**
 * SafeImage - <img> wrapper que esconde graciosamente quando a URL quebra
 * (URLs órfãs, storage antigo, etc). Em vez de mostrar o ícone de imagem quebrada
 * do browser, esconde a img e (se fornecido) renderiza um fallback.
 */
export const SafeImage = ({ fallback = null, className = "", ...props }) => {
    const [failed, setFailed] = useState(false);
    if (!props.src || failed) return fallback;
    return (
        <img
            {...props}
            className={className}
            onError={() => setFailed(true)}
        />
    );
};

export default SafeImage;
